import dayjs from "dayjs";

/**
 * @description - Returns true if manualDueDate is today or a future date
 * @param manualDueDate - Case manual due date
 * @returns
 */
export function isFutureOrTodayManualDueDate(
  manualDueDate: string | Date | null
): boolean {
  try {
    if (!manualDueDate) return false;

    const date = dayjs(manualDueDate);
    if (!date.isValid()) return false;

    return date.isSame(dayjs(), "day") || date.isAfter(dayjs(), "day");
  } catch {
    return false;
  }
}
